const newhouse = [
  //  新房首页-主列表
  {
    name: '_newhouse-list',
    path: '/newhouse/:filterIndex?',
    mPath: params => `https://m.fccs.com/${params.domain}/newhouse/${params.filterIndex || ''}`,
    // 用于菜单高亮
    menuCode: 'newhouse_v5',
    file: 'pages/newhouse/list/[[filterIndex]].vue',
    pageTypeId: 11,
  },
  // 新房首页 - 商铺
  {
    name: '_newhouse-shop',
    path: '/shop/:filterIndex?',
    mPath: params => `https://m.fccs.com/${params.domain}/shop/${params.filterIndex || ''}`,
    // 用于菜单高亮
    menuCode: 'newhouse_shop_v5',
    file: 'pages/newhouse/list/[[filterIndex]].vue',
    pageTypeId: 26,
  },
  // 新房首页 - 写字楼
  {
    name: '_newhouse-office',
    path: '/office/:filterIndex?',
    mPath: params => `https://m.fccs.com/${params.domain}/office/${params.filterIndex || ''}`,
    // 用于菜单高亮
    menuCode: 'newhouse_office_v5',
    file: 'pages/newhouse/list/[[filterIndex]].vue',
    pageTypeId: 26,
  },
  //  主题找房【新链接】
  {
    name: '_newhouse-themefindroom-list',
    path: '/newhouse/themefindroom.html',
    mPath: params => `https://m.fccs.com/${params.domain}/newhouse/themefindroom.html`,
    // 用于菜单高亮
    menuCode: 'theme_search_v5',
    file: 'pages/newhouse/themefindroom/index.vue',
    meta: {
      layout: 'brand-layout',
    },
    pageTypeId: 18,
  },
  //  主题找房【新链接】
  {
    name: '_newhouse-themefindroom',
    path: '/newhouse/themefindroom_:themeId?.html',
    mPath: params => `https://m.fccs.com/${params.domain}/newhouse/themefindroom_${params.themeId}.html`,
    // 用于菜单高亮
    menuCode: 'theme_search_v5',
    file: 'pages/newhouse/themefindroom/index.vue',
    meta: {
      layout: 'brand-layout',
    },
    pageTypeId: 18,
  },
  //  品牌找房【新链接】
  {
    name: '_newhouse-brandlist',
    path: '/newhouse/brandfindroom/brandlist.html',
    mPath: params => `https://m.fccs.com/${params.domain}/newhouse/brandfindroom/brandlist.html`,
    // 用于菜单高亮
    menuCode: 'brand_search_v5',
    file: 'pages/newhouse/brandfindroom/brandlist/index.vue',
    meta: {
      layout: 'brand-layout',
    },
    pageTypeId: 19,
  },
  //  品牌找房-品牌详情【新链接】
  {
    name: '_newhouse-brandlist-detail',
    path: '/newhouse/brandfindroom/floorlist/:brandId.html',
    mPath: params => `https://m.fccs.com/${params.domain}/newhouse/brandfindroom/floorlist/${params.brandId}.html`,
    // 用于菜单高亮
    menuCode: 'brand_search_v5',
    file: 'pages/newhouse/brandfindroom/floorlist/[[brandId]].vue',
    meta: {
      layout: 'brand-layout',
    },
    pageTypeId: 19,
  },
  //  地图找房
  {
    name: '_newhouse-map',
    path: '/newhouse/map/newhouse/',
    mPath: params => `https://m.fccs.com/${params.domain}/newhouse/map/`,
    // 用于菜单高亮
    menuCode: '',
    file: 'pages/newhouse/findhouse/index.vue',
    pageTypeId: 21,
  },
  //   新房榜单【新链接】
  {
    name: '_newhouse-ranking-default',
    path: '/newhouse/ranking.html',
    mPath: params => `https://m.fccs.com/${params.domain}/newhouse/ranking.html`,
    // 用于菜单高亮
    menuCode: 'rank_list_v5',
    file: 'pages/newhouse/ranking/index.vue',
    meta: {
      layout: 'brand-layout',
    },
    pageTypeId: 16,
  },
  //   新房榜单【新链接】
  {
    name: '_newhouse-ranking',
    path: '/newhouse/ranking_:rankingTypeId.html',
    mPath: params => `https://m.fccs.com/${params.domain}/newhouse/ranking_${params.rankingTypeId}.html`,
    // 用于菜单高亮
    menuCode: 'rank_list_v5',
    file: 'pages/newhouse/ranking/index.vue',
    meta: {
      layout: 'brand-layout',
    },
    pageTypeId: 16,
  },
  // 新房详情-楼盘首页
  {
    name: '_newhouse-index',
    path: '/newhouse/:floorId(\\d+)/index.html',
    mPath: params => `https://m.fccs.com/${params.domain}/newhouse/${params.floorId}/index.html`,
    // 用于菜单高亮
    menuCode: '',
    file: 'pages/newhouse/detail/[floorId].vue',
    meta: {
      layout: 'new-house-index-detail',
      tabActive: 0,
    },
    pageTypeId: 1,
  },
  // 写字楼详情-楼盘首页
  {
    name: '_newhouse-office-detail',
    path: '/office/:floorId(\\d+)/index.html',
    mPath: params => `https://m.fccs.com/${params.domain}/office/${params.floorId}/index.html`,
    // 用于菜单高亮
    menuCode: '',
    file: 'pages/newhouse/detail/[floorId].vue',
    meta: {
      layout: 'new-house-index-detail',
      tabActive: 0,
    },
    pageTypeId: 1,
  },
  // 新商铺详情-楼盘首页
  {
    name: '_newhouse-shop-detail',
    path: '/shop/:floorId(\\d+)/index.html',
    mPath: params => `https://m.fccs.com/${params.domain}/shop/${params.floorId}/index.html`,
    // 用于菜单高亮
    menuCode: '',
    file: 'pages/newhouse/detail/[floorId].vue',
    meta: {
      layout: 'new-house-index-detail',
      tabActive: 0,
    },
    pageTypeId: 1,
  },
  // 新房详情-周边配套
  {
    name: '_newhouse-mapdetail',
    path: '/newhouse/mapdetail/:floorId(\\d+)/index.html',
    mPath: params => `https://m.fccs.com/${params.domain}/newhouse/${params.floorId}/floorDetailMap.html`,
    // 用于菜单高亮
    menuCode: '',
    file: 'pages/newhouse/mapdetail/[floorId].vue',
    meta: {
      layout: 'floor-layout',
      tabActive: 7,
    },
    pageTypeId: 7,
  },
  //  新房详情-楼盘详情
  {
    name: '_newhouse-brief',
    path: '/newhouse/:floorId(\\d+)/brief.html',
    mPath: params => `https://m.fccs.com/${params.domain}/newhouse/${params.floorId}/detail.html`,
    // 用于菜单高亮
    menuCode: '',
    file: 'pages/newhouse/detail/propertydetails/[floorId]/index.vue',
    meta: {
      layout: 'floor-layout',
      tabActive: 1,
    },
    pageTypeId: 2,
  },
  //  todo 新房详情-楼盘相册（不同的相册类型url相同）
  {
    name: '_newhouse-photo',
    path: '/newhouse/:floorId/photo.html',
    mPath: params => `https://m.fccs.com/${params.domain}/newhouse/${params.floorId}/photo.html`,
    // 用于菜单高亮
    menuCode: '',
    file: 'pages/newhouse/flooralbum/[floorId].vue',
    meta: {
      layout: 'floor-layout',
      tabActive: 2,
    },
    pageTypeId: 3,
  },
  //  新房详情-户型列表
  {
    name: '_newhouse-model',
    path: '/newhouse/:floorId(\\d+)/model.html',
    mPath: params => `https://m.fccs.com/${params.domain}/newhouse/${params.floorId}/model.html`,
    // 用于菜单高亮
    menuCode: '',
    file: 'pages/newhouse/detail/housegroup/[floorId]/index.vue',
    meta: {
      layout: 'floor-layout',
      tabActive: 3,
    },
    // 隐私号埋点
    businessDataId: 2,
    pageTypeId: 4,
  },
  //  新房详情-户型详情
  {
    name: '_newhouse-model-detil',
    path: '/newhouse/:floorId(\\d+)/model\\_:houseModelId.html',
    mPath: params => `https://m.fccs.com/${params.domain}/newhouse/${params.floorId}/model_${params.houseModelId}.html`,
    // 用于菜单高亮
    menuCode: '',
    file: 'pages/newhouse/detail/housegroup/[floorId]/[houseModelId].vue',
    meta: {
      layout: 'floor-layout',
      tabActive: 3,
    },
    // 隐私号埋点
    businessDataId: 2,
    // todo 户型详情参数传递方式，无户型详情tdk
    pageTypeId: 5,
  },
  //  新房- 看房团列表
  {
    name: '_newhouse-group',
    path: '/newhouse/kanfang.html',
    mPath: params => `https://m.fccs.com/${params.domain}/newhouse/kanfang/`,
    // 用于菜单高亮
    menuCode: 'house_visit_v5',
    file: 'pages/newhouse/freelookhouse/index.vue',
    meta: {
      layout: 'brand-layout',
      tabActive: 3,
    },
    pageTypeId: 23,
  },
  // 新房 - 看房团详情
  {
    name: '_newhouse-group-detail',
    path: '/newhouse/kanfang/:visitId.html',
    mPath: params => `https://m.fccs.com/${params.domain}/newhouse/kanfang/${params.visitId}/index.html`,
    // 用于菜单高亮
    menuCode: 'house_visit_v5',
    file: 'pages/newhouse/freelookhouse/detail.vue',
    meta: {
      layout: 'brand-layout',
    },
    // todo 详情信息tdk
    pageTypeId: 24,
  },
  //  todo 新房详情-楼盘评测【新链接】（首次打开楼盘评测与已报名的楼盘评测页url相同）
  {
    name: '_newhouse-evaluate',
    path: '/newhouse/floorEvaluating/:floorId.html',
    mPath: params => `https://m.fccs.com/${params.domain}/newhouse/${params.floorId}/evaluating.html`,
    // 用于菜单高亮
    menuCode: '',
    file: 'pages/newhouse/floorEvaluating.vue',
    meta: {
      layout: 'floor-layout',
      tabActive: 4,
    },
    pageTypeId: 6,
  },
  //  新房详情-房价分析
  {
    name: '_newhouse-house-price-analysis',
    path: '/newhouse/:floorId(\\d+)/price.html',
    mPath: params => `https://m.fccs.com/${params.domain}/newhouse/priceanalysis/${params.floorId}.html`,
    // 用于菜单高亮
    menuCode: '',
    file: 'pages/newhouse/housePriceAnalysis/[floorId].vue',
    meta: {
      layout: 'floor-layout',
      tabActive: 5,
    },
    pageTypeId: 8,
  },
  // {
  //     name: '_newhouse-model-detil',
  //     path: '/newhouse/:floorId(\\d+)/model\\_:houseModelId.html',
  // },
  //  todo 新房详情-楼栋信息【新链接】（不同情况下的楼栋信息url相同，不同分页url相同，（未报名/一房一价/户型））
  {
    name: '_newhouse-building',
    path: '/newhouse/oneprice/:floorId.html',
    mPath: params => `https://m.fccs.com/${params.domain}/newhouse/${params.floorId}/buildingView.html`,
    // 用于菜单高亮
    menuCode: '',
    file: 'pages/newhouse/oneprice/[floorId].vue',
    meta: {
      layout: 'floor-layout',
      tabActive: 6,
    },
    pageTypeId: 9,
  },
  //  todo 新房详情-楼栋信息-房源详情（老链接不清楚）
  {
    name: '_newhouse-houseDetail',
    path: '/newhouse/detail/:floorId/houseDetail/:floorHouseId',
    mPath: params => `https://m.fccs.com/${params.domain}/newhouse/${params.floorId}/onepricedetail/${params.floorHouseId}.html`,
    // 用于菜单高亮
    menuCode: '',
    file: 'pages/newhouse/detail/houseDetail/[floorHouseId].vue',
    // 隐私号埋点
    businessDataId: 3,
    // todo tdk缺pageTypeId
    pageTypeId: 9,
  },
  //  新房详情-楼盘动态-动态列表and楼盘资讯
  {
    name: '_newhouse-news-list',
    path: '/newhouse/:floorId(\\d+)/news.html',
    mPath: params => `https://m.fccs.com/${params.domain}/newhouse/${params.floorId}/news.html`,
    // 用于菜单高亮
    menuCode: '',
    file: 'pages/newhouse/detail/real-estate-dynamics/[floorId].vue',
    meta: {
      layout: 'floor-layout',
      tabActive: 8,
    },
    pageTypeId: 10,
  },
  //  新房详情-楼盘动态-动态列表and楼盘资讯 TDK需要用到 floorNewsTab
  {
    name: '_newhouse-news',
    path: '/newhouse/:floorId(\\d+)/news_:floorNewsTab.html',
    mPath: params => `https://m.fccs.com/${params.domain}/newhouse/${params.floorId}/news_${params.floorNewsTab}.html`,
    // 用于菜单高亮
    menuCode: '',
    file: 'pages/newhouse/detail/real-estate-dynamics/[floorId].vue',
    meta: {
      layout: 'floor-layout',
      tabActive: 8,
    },
    pageTypeId: 10,
  },
]
// module.exports = newhouse
export default newhouse
